import { useMemo } from "react";

import { VCS_PROVIDERS_ICONS } from "constants/provider_icons";
import { generateRepoUrl, generateRepoUrlText } from "utils/urls";
import { Module } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableCellRepository from "ds/components/Table/Row/CellRepository";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import { ModulesSuggestions } from "../../FiltersLayout/constants";
import useModulesAnalytics from "../../useModulesAnalytics";
import useCellFilterAction from "../useCellFilterAction";

const ModulesTableRepositoryCell = ({
  item: module,
  ...cellProps
}: TableSimpleCellProps<Module>) => {
  const trackAnalytics = useModulesAnalytics();

  const repositoryName = generateRepoUrlText({
    namespace: module.namespace,
    repository: module.repository,
  });

  const repositoryFilterAction = useCellFilterAction({
    filterName: ModulesSuggestions.Repository,
    filterValue: repositoryName,
  });

  const actions = useMemo(() => [repositoryFilterAction], [repositoryFilterAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      {!module.apiHost && <TableCellEmpty />}

      {module.apiHost && (
        <TableCellRepository
          href={generateRepoUrl({
            apiHost: module.apiHost,
            namespace: module.namespace,
            repository: module.repository,
            repositoryURL: module.repositoryURL || "",
            provider: module.provider,
          })}
          onPress={() => trackAnalytics("Repository link clicked")}
          startIcon={VCS_PROVIDERS_ICONS[module.provider]}
        >
          {repositoryName}
        </TableCellRepository>
      )}
    </TableSimpleCell>
  );
};

export default ModulesTableRepositoryCell;
